export default function ParagraphAnswerEditor({ question, onUpdate }) {
  const isList = question.isListMode;
  const text = question.value || "";
  const options = question.options || [];

  const handleTextChange = (e) => {
    onUpdate(question.id, { value: e.target.value });
  };

  const handleListChange = (e) => {
    const lines = e.target.value.split("\n");
    const newOptions = lines.map((line, idx) => {
      const value = line.startsWith("•")
        ? line.slice(line[1] === " " ? 2 : 1)
        : line;
      return { index: idx, value };
    });
    onUpdate(question.id, { options: newOptions });
  };
  const handleKeyDown = (e) => {
    const { value, selectionStart, selectionEnd } = e.target;

    // ENTER: insert bullet point on new line
    if (e.key === "Enter") {
      e.preventDefault();
      const textBefore = value.substring(0, selectionStart);
      const textAfter = value.substring(selectionEnd);
      const currentLine = textBefore.split("\n").pop();
      const hasContent = currentLine.replace(/^•\s*/, "").trim() !== "";

      const newValue = `${textBefore}\n${hasContent ? "• " : ""}${textAfter}`;
      e.target.value = newValue;

      setTimeout(() => {
        const newPos = selectionStart + 1 + (hasContent ? 2 : 0);
        e.target.selectionStart = newPos;
        e.target.selectionEnd = newPos;
      }, 0);

      const event = new Event("input", { bubbles: true });
      e.target.dispatchEvent(event);
    }

    // BACKSPACE: remove bullet if at start
    if (e.key === "Backspace" && selectionStart === selectionEnd) {
      const lineStart = value.lastIndexOf("\n", selectionStart - 1) + 1;
      const beforeCursor = value.substring(lineStart, selectionStart);

      if (beforeCursor === "• " || beforeCursor === "•") {
        e.preventDefault();
        e.target.value =
          value.substring(0, lineStart) + value.substring(selectionStart);
        setTimeout(() => {
          e.target.selectionStart = lineStart;
          e.target.selectionEnd = lineStart;
        }, 0);
        const event = new Event("input", { bubbles: true });
        e.target.dispatchEvent(event);
      }
    }
  };

  return (
    <div>
      <p>Your Paragraph here</p>
      <div className="w-full border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-700">
        <div className="flex px-3 py-2 border-b border-gray-200 dark:border-gray-600">
          <button
            className={`text-sm p-1 rounded ${
              !isList ? "text-blue-600 font-semibold" : "text-gray-600"
            } hover:text-black`}
            onClick={() =>
              onUpdate(question.id, {
                isListMode: false,
                value: "",
                options: [],
              })
            }
          >
            <svg
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth="2"
                d="M5 7h14M5 12h14M5 17h10"
              />
            </svg>
          </button>
          <span className="px-2 text-gray-300">|</span>
          <button
            className={`text-sm p-1 rounded ${
              isList ? "text-blue-600 font-semibold" : "text-gray-600"
            } hover:text-black`}
            onClick={() =>
              onUpdate(question.id, { isListMode: true, value: "" })
            }
          >
            <svg
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeWidth="2"
                d="M9 8h10M9 12h10M9 16h10M4.99 8H5m-.02 4h.01m0 4H5"
              />
            </svg>
          </button>
        </div>
        <div className="px-4 py-2 bg-white dark:bg-gray-800">
          <textarea
            rows="8"
            className="w-full text-sm text-gray-800 bg-white border-0 dark:bg-gray-800 focus:ring-0 dark:text-white"
            value={
              isList ? options.map((o) => `• ${o.value}`).join("\n") : text
            }
            onChange={isList ? handleListChange : handleTextChange}
            onKeyDown={isList ? handleKeyDown : undefined}
            placeholder={
              isList ? "• Enter each point on a new line" : "Write text here..."
            }
          />
        </div>
      </div>
    </div>
  );
}
